/**
 * #1274: a short list of common personal mail domains. People sign in with a Microsoft work or
 * school account, so an address at one of these usually cannot sign in. Grant access still
 * accepts it (owner decision 2026-10-16): this only feeds a warning, never a refusal.
 */
const PERSONAL_EMAIL_DOMAINS: readonly string[] = [
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "yahoo.com",
  "icloud.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
];

/** True when the address is complete and its domain is on the personal list (case ignored). */
export function isPersonalEmail(email: string): boolean {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf("@");
  if (at < 1 || /\s/.test(trimmed)) return false;
  return PERSONAL_EMAIL_DOMAINS.includes(trimmed.slice(at + 1));
}
